<div id="wrapper">
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav
            (updatePostpaid)="this.postpago=$event"
            (updatePrepaid)="this.prepago=$event"
            (updateFixed)="this.telefoniaFijo=$event"
            (updateTotalAccountList)="this.totalAccountList=$event"
            (updateCurrentList)="this.currentList=$event"
            (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <div class="allcont logsize">
        <!-- AREA DE TRABAJO -->
        <!-- TITULO DE VENTANA PRINCIPAL -->
        <div class="basicrow m-top-i">
            <div class="container">
                <div class="basicr-line-i">
                    <div class="fulltitle f-btitle autodef">
                        <span class="icon-dash-13"></span> Reporte de Aver&iacute;as
                    </div>
                    <div class="pull-right">
                        <label class="label-r sidenmbr vcenter w-auto">
                            <span class="tabcell">
                                N&uacute;mero de Cuenta
                            </span>
                        </label>
                        <div class="autorow subsc mob-wid pull-right">
                            <div *ngIf="this.totalAccountList > 0">
                                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f"
                                    style="background-image:url(/assets/images/selectabarrw.png)">
                                    <option *ngFor="let list of this.currentList" [ngValue]="list.account">
                                        {{list.account}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <!-- AQUI VA LA LISTA QUE CONTINENE EL NUMERO DE CUENTA -->
                </div>
            </div>
        </div>
        <!-- NUMEROS DE CUENTAS ASOCIADAS -->
        <div class="basicrow mbott m-top-i">
            <!-- BORDES -->
            <div class="container">
                <div class="autowcont notopbrd " *ngFor="let subscriber of this.subscribers; let i = index">
                    <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt" (click)="updateExpand(i)" [ngClass]="{'mon': this.expand[i] == true,'': this.expand[i] == false}">
                        <div class="tabcell">
                            <div *ngIf="subscriber.productTypeField=='G'">
                                <span class="roboto-l">M&Oacute;VIL </span>
                                <span class="roboto-m">{{this.global.mask(subscriber.subscriberNumberField)}}</span>
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                            </div>
                            <div *ngIf="subscriber.productTypeField!=='G'">
                                <span class="roboto-l">TELEFONÍA FIJA </span>
                                <span class="roboto-m">{{this.global.mask(subscriber.subscriberNumberField)}}</span>
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <!-- FIN NUMEROS DE CUENTAS ASOCIADAS -->
                    <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                        <div class="basicrow" *ngIf="subscriber.productTypeField!=='G'">
                            <div class="container">
                                <div class="basicrow m-top-i m-bott text-center ">
                                    <div class="stepsvone">
                                        <div class="stepautoc first" [ngClass]="this.screenView[i]==1 ? 'on' : ' '">
                                            Tipo de Aver&iacute;a
                                            <div class="stepcirc text-center">
                                                <div class="circ-in"></div>
                                            </div>
                                        </div>
                                        <div class="stepautoc middle" [ngClass]="this.screenView[i]==2 ? 'on' : ' '">
                                            Detalles
                                            <div class="stepcirc">
                                                <div class="circ-in"></div>
                                            </div>
                                        </div>
                                        <div class="stepautoc last" [ngClass]="this.screenView[i]==3 ? 'on' : ' '">
                                            Confirmaci&oacute;n
                                            <div class="stepcirc">
                                                <div class="circ-in"></div>
                                            </div>
                                        </div>
                                        <div class="stepsline"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="this.screenView[i]==1">
                            <app-typebreakdown-faultreport [index]="i" [screenView]="this.screenView"
                                [subscriber]="subscriber.subscriberNumberField"
                                [productType]="subscriber.productTypeField" (updateScreenView)="this.screenView=$event"
                                (typeOfBreakdown)="this.typeOfBreakdown=$event">
                            </app-typebreakdown-faultreport>
                        </div>
                        <app-lineonly-faultreport [index]="i" [subscriber]="subscriber.subscriberNumberField"
                            [productType]="subscriber.productTypeField" [selectBan]="this.selectBan"
                            [typeOfBreakdown]="this.typeOfBreakdown" [screenView]="this.screenView"
                            (updateScreenView)="this.screenView=$event" (respuesta)="this.respuesta=$event">
                        </app-lineonly-faultreport>
                        <app-faultconfirmation-faultreport [index]="i" [screenView]="this.screenView"
                            (updateScreenView)="this.screenView=$event" [respuesta]="this.respuesta"
                            (screenView2)="this.screenView=$event">
                        </app-faultconfirmation-faultreport>
                    </div>
                </div>
                <!-- FIN CICLO -->
            </div>
        </div>
        <!-- FIN BORDES -->
    </div>
    <!-- FIN DE TRABAJO -->
    <app-footer></app-footer>
</div>
